<div class="su-form-container">
  <ngx-spinner name="su-form-spinner" bdColor="rgba(0,0,0,0.3)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="color: white">Saving...</p>
  </ngx-spinner>

  <nb-card>
    <nb-card-header>
      <h5 class="mb-0">{{ isEdit ? 'Edit System Update' : 'New System Update' }}</h5>
    </nb-card-header>

    <nb-card-body>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <!-- Title -->
        <div class="form-group mb-3">
          <label class="form-label">Title <span class="text-danger">*</span></label>
          <input nbInput fullWidth formControlName="title" placeholder="Update title" />
          <div class="text-danger small mt-1"
               *ngIf="form.get('title')?.invalid && form.get('title')?.touched">
            Title is required.
          </div>
        </div>

        <!-- State -->
        <div class="form-group mb-3">
          <label class="form-label">State <span class="text-danger">*</span></label>
          <nb-select formControlName="state" fullWidth>
            <nb-option value="planned">Planned</nb-option>
            <nb-option value="implemented">Implemented</nb-option>
          </nb-select>
        </div>

        <!-- Body -->
        <div class="form-group mb-4">
          <label class="form-label">Description <span class="text-danger">*</span></label>
          <angular-editor formControlName="body" [config]="editorConfig"></angular-editor>
          <div class="text-danger small mt-1"
               *ngIf="form.get('body')?.invalid && form.get('body')?.touched">
            Description is required.
          </div>
        </div>

        <!-- Actions -->
        <div class="d-flex gap-2">
          <button type="submit" nbButton status="primary" [disabled]="submitting">
            {{ isEdit ? 'Save Changes' : 'Create Update' }}
          </button>
          <button type="button" nbButton ghost (click)="onCancel()">Cancel</button>
        </div>

      </form>
    </nb-card-body>
  </nb-card>
</div>
